"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.internalUseTransaction = void 0;
const tslib_1 = require("tslib");
const ImpactProvider_1 = require("./ImpactProvider");
const contracts_1 = require("./contracts");
const react_1 = require("react");
const axios_1 = tslib_1.__importDefault(require("axios"));
const apiGetAccountNonce = async (jsonRpcUrl, address) => {
    const response = await axios_1.default.post(jsonRpcUrl, {
        id: 1,
        jsonrpc: '2.0',
        method: 'eth_getTransactionCount',
        params: [address, 'latest']
    });
    const { result } = response.data;
    const nonce = parseInt(result, 16);
    return nonce;
};
const apiGetGasPrice = async (jsonRpcUrl, defaultFeeCurrency) => {
    const response = await axios_1.default.post(jsonRpcUrl, {
        id: 1,
        jsonrpc: '2.0',
        method: 'eth_gasPrice',
        params: defaultFeeCurrency ? [defaultFeeCurrency] : []
    });
    const { result } = response.data;
    return result;
};
const internalUseTransaction = () => {
    const { signer, address, provider, networkId, defaultFeeCurrency, jsonRpcUrl, connection } = (0, react_1.useContext)(ImpactProvider_1.ImpactProviderContext);
    // internal transaction formatter
    const formatTransaction = async (tx) => {
        if (!address) {
            throw new Error('no valid address connected');
        }
        const [_nonce, _gasPrice, _gasLimit, _value] = await Promise.all([
            apiGetAccountNonce(jsonRpcUrl, tx.from || address),
            apiGetGasPrice(jsonRpcUrl, defaultFeeCurrency),
            // ensure basic params are provided
            provider.estimateGas(Object.assign(Object.assign({}, tx), { from: address })),
            0
        ]);
        return Object.assign(Object.assign({}, tx), { account: (tx.from || address), gas: BigInt(_gasLimit.toNumber() * 2), gasPrice: BigInt(_gasPrice), nonce: _nonce, value: BigInt(_value) });
    };
    const executeTransaction = async (tx) => {
        if (!address) {
            throw new Error('no valid address connected');
        }
        const { celo } = (0, contracts_1.getContracts)(provider, networkId);
        // include fee currency on tx parameters
        let feeTxParams = {};
        if (defaultFeeCurrency && defaultFeeCurrency.toLowerCase() !== celo.address.toLowerCase()) {
            feeTxParams = {
                feeCurrency: defaultFeeCurrency
            };
        }
        if (!signer) {
            throw new Error('no valid signer connected');
        }
        if (signer === null && connection) {
            const txResponse = await connection.sendTransaction({
                data: tx.data,
                from: tx.from || address,
                gasPrice: await apiGetGasPrice(jsonRpcUrl, defaultFeeCurrency),
                to: tx.to
            });
            return await txResponse.waitReceipt();
        }
        const txHash = await signer.sendTransaction(Object.assign(Object.assign({}, (await formatTransaction(tx))), feeTxParams));
        try {
            if (typeof document !== 'undefined') {
                // I'm on the web!
                // import('@sentry/nextjs').then((SentryNextJS) => {
                //     SentryNextJS.addBreadcrumb({
                //         category: 'blockchain',
                //         level: 'info',
                //         message: JSON.stringify({ tx, txParams })
                //     });
                // });
            }
            else {
                // import('@sentry/react-native').then((SentryReactNative) => SentryReactNative.addBreadcrumb({
                //     category: 'blockchain',
                //     level: 'info',
                //     message: JSON.stringify({ tx, txParams })
                // }));
            }
        }
        catch (_) { }
        // initial version of utils returned the transaction receipt
        // and it's used in many places, so we will keep doing it
        return await provider.waitForTransaction(txHash);
    };
    return executeTransaction;
};
exports.internalUseTransaction = internalUseTransaction;
//# sourceMappingURL=internalUseTransaction.js.map